import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import ViewDiscount from "../components/discounts/shared/viewDiscount";
import AddEditPayXGetFree from "../components/discounts/payXGetFree/addEditPayXGetFree";
import CommonDiscountList from "../shared/commonComponents/commonDiscountList";

const PayXGetFreeDiscount = () => <CommonDiscountList type="PayXGetFree" />

// custom imports
/* 
  Functional component to hold all the pages in a stack navigator
 */
const PayXGetFreeStack = () => {
    // Variable to handle appStack
    const AppStack = createStackNavigator();

    return (
        <AppStack.Navigator
            initialRouteName={"PayXGetFree"}
            screenOptions={{ headerShown: false }}>
            <AppStack.Screen name="PayXGetFree" component={PayXGetFreeDiscount} />
            <AppStack.Screen name="AddEditPayXGetFree" component={AddEditPayXGetFree} />
            <AppStack.Screen name="ViewDiscount" component={ViewDiscount} />
        </AppStack.Navigator>
    );
};

export default PayXGetFreeStack;